// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--S__gH","bounce":"hero-module--bounce--3emkr","heroright":"hero-module--heroright--2D3wj","header":"hero-module--header--1rmnP"};